import { Select } from "@mui/material";
import * as React from "react";
import { IIdTitleNode, IdTitleNode } from "../../../../models/common/idTitleNode";
import { ITreeCheckBoxDropdownItem, TreeCheckBoxDropdownItems } from "./TreeCheckboxDropdownItems";
import { TreeCheckboxDropdownValueWithComment } from "./TreeCheckboxDropdownValueWithComment";

export interface ITreeCheckboxDropdownProp {
    autoFocus?: boolean;
    classes?: string;
    buttonClasses?: string;
    disabled?: boolean;
    menuRight?: boolean;
    required?: boolean;
    selectedIds: string[];
    singleSelect?: boolean;
    toggleAllId?: string;
    toggleNotSetId?: string;
    hideParentsInSelection?: boolean;
    showCommentInSelection?: boolean;
    showCommentInDropdown?: boolean;
    selectSubSectionValuesByTitle?: boolean;
    values: ITreeCheckBoxDropdownItem[];
    onChange: (selectedIds: string[]) => void;
    onClose?: () => void;
    onGetTitleSuffix?: (id: string) => React.ReactNode | string;
}

export interface ITreeCheckboxDropdownState {
    open: boolean;
    selectedValueStr: string;
    selectedValue: React.ReactNode | string;
}

export class TreeCheckboxDropdown extends React.Component<ITreeCheckboxDropdownProp, ITreeCheckboxDropdownState> {
    private getSelectedNodes = (props: ITreeCheckboxDropdownProp): IIdTitleNode[] => {
        let result = IdTitleNode.getByIds(props.values, props.selectedIds);
        if (props.hideParentsInSelection) {
            result = result.filter(i => !i.hasChildren());
        }
        return result;
    };

    private getSelectedValueStr = (props: ITreeCheckboxDropdownProp, selectedNodes: IIdTitleNode[]): string => {
        if (!props.showCommentInSelection) {
            return selectedNodes.map(i => i.getTitle()).join(", ");
        } else {
            return selectedNodes.map(i => i.getTitle() + (i.comment ? " (" + i.comment + ")" : "")).join(", ");
        }
    };

    private getSelectedValue = (props: ITreeCheckboxDropdownProp, selectedNodes: IIdTitleNode[], selectedValueStr: string): React.ReactNode | string => {
        if (props.showCommentInSelection && props.singleSelect && selectedNodes.length === 1) {
            const item = selectedNodes[0];
            return <TreeCheckboxDropdownValueWithComment item={item} />;
        }
        return selectedValueStr;
    };

    constructor(props: ITreeCheckboxDropdownProp) {
        super(props);
        const selectedNodes = this.getSelectedNodes(props);
        const selectedValueStr = this.getSelectedValueStr(props, selectedNodes);
        this.state = {
            open: false,
            selectedValueStr,
            selectedValue: this.getSelectedValue(props, selectedNodes, selectedValueStr)
        };
    }

    componentDidUpdate(prevProps: ITreeCheckboxDropdownProp, prevState: ITreeCheckboxDropdownState): void {
        const selectedNodes = this.getSelectedNodes(this.props);
        const selectedValueStr = this.getSelectedValueStr(this.props, selectedNodes);
        if (prevState.selectedValueStr === selectedValueStr) return;
        this.setState({
            selectedValueStr,
            selectedValue: this.getSelectedValue(this.props, selectedNodes, selectedValueStr)
        });
    }

    handleClearClick = () => {
        const props = this.props;
        if (props.disabled) return;
        props.onChange([]);
    };

    handleClose = () => {
        this.setState({
            open: false
        });
        this.props.onClose?.();
    };
    
    handleOpen = () => {
        this.setState({
            open: true
        });
    };

    handleToggleDropdown = () => {
        this.setState({
            open: !this.state.open
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <>
                <Select
                    multiple
                    disabled={props.disabled}
                    autoFocus={props.autoFocus}
                    value={props.selectedIds}
                    open={state.open}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    renderValue={() => state.selectedValue}
                    size="small"
                    fullWidth
                >
                    <TreeCheckBoxDropdownItems
                        disabled={props.disabled}
                        selectedIds={props.selectedIds}
                        selectSubSectionValuesByTitle={props.selectSubSectionValuesByTitle}
                        singleSelect={props.singleSelect}
                        showComment={props.showCommentInDropdown}
                        toggleAllId={props.toggleAllId}
                        toggleNotSetId={props.toggleNotSetId}
                        values={props.values}
                        onChange={props.onChange}
                        onToggleDropdown={this.handleToggleDropdown}
                        onGetTitleSuffix={props.onGetTitleSuffix}
                    />
                </Select>
            </>
        );
    }
}